import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteBrandSaga,
  getBrandDetailsSaga,
  getBrandListSaga,
  getSubBrandListByParentIdSaga,
} from "src/store/brands/saga";
import { BrandDetailDto, BrandDto } from "src/store/brands/type";
import BrandCreateForm from "./create";
import BrandEditForm from "./edit";
const BrandPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<BrandDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const navigate = useNavigate();
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<BrandDetailDto>();
  const columns = [
    {
      text: t("Brand.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Brand.PageTitle")}
        metaTag={t("Brand.MetaTag")}
        gridProps={{
          addTitle: t("Brand.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getBrandListSaga,

          onCreateClick: () => setShowCreate(true),
          gridButtons(keyValue, data) {
            return (
              <ColumnButton
                buttonType={"custom"}
                custombutton={{
                  text: t("Brand.SubBrandColumnButton").toString(),
                }}
                onClick={() => navigate("/asset/brands/subs/" + data.Id)}
              />
            );
          },
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getBrandDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: BrandDto) =>
              t("Brand.DeleteQA", {
                name: data.Name,
              }),
            action: deleteBrandSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <BrandCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getBrandListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <BrandEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getBrandListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default BrandPage;
